module.exports = __webpack_public_path__ + "img/sequence-label.c5b975be.png";